"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
var FetchProvider_1 = require("../common/js/services/requestHttp/implementations/FetchProvider");
var SwalProvider_1 = require("../common/js/services/alert/implementations/SwalProvider");
exports.Config = {
    requestProvider: FetchProvider_1.FetchProvider,
    alertProvider: SwalProvider_1.SwalProvider,
    alertProviderFrontOffice: SwalProvider_1.SwalProvider,
};
